import { render, staticRenderFns } from "./RunnitsSCSS.vue?vue&type=template&id=3cd1a3af"
import script from "./RunnitsSCSS.vue?vue&type=script&lang=js"
export * from "./RunnitsSCSS.vue?vue&type=script&lang=js"
import style0 from "./RunnitsSCSS.vue?vue&type=style&index=0&id=3cd1a3af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports